import { gql } from "@apollo/client";

export const GetUsersQuery = gql`
  query GetUsers($params: GetUsersInput!) {
    getUsers(params: $params) {
      users {
        authMethod
        email
        firstName
        lastName
        status
        username
        roles
        groups
        attributes
        lastLogin
      }
      lastEvaluatedKey {
        username
      }
    }
  }
`;
